"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Promptable = require("UIComponents/decorators/Promptable");

var _Promptable2 = _interopRequireDefault(_Promptable);

var _PromptablePropInterface = require("UIComponents/decorators/PromptablePropInterface");

var _PromptablePropInterface2 = _interopRequireDefault(_PromptablePropInterface);

var _UIModal = require("UIComponents/dialog/UIModal");

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIDialogHeader = require("UIComponents/dialog/UIDialogHeader");

var _UIDialogHeader2 = _interopRequireDefault(_UIDialogHeader);

var _UIDialogBody = require("UIComponents/dialog/UIDialogBody");

var _UIDialogBody2 = _interopRequireDefault(_UIDialogBody);

var _UIDialogFooter = require("UIComponents/dialog/UIDialogFooter");

var _UIDialogFooter2 = _interopRequireDefault(_UIDialogFooter);

var _UIDialogCloseButton = require("UIComponents/dialog/UIDialogCloseButton");

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _Cropper = require("./Cropper");

var _Cropper2 = _interopRequireDefault(_Cropper);

var _UIButton = require("UIComponents/button/UIButton");

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UISection = require("UIComponents/section/UISection");

var _UISection2 = _interopRequireDefault(_UISection);

var _DropzoneUploader = require("./DropzoneUploader");

var _DropzoneUploader2 = _interopRequireDefault(_DropzoneUploader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Uploader = function (_Component) {
  _inherits(Uploader, _Component);

  function Uploader(props) {
    _classCallCheck(this, Uploader);

    var _this = _possibleConstructorReturn(this, (Uploader.__proto__ || Object.getPrototypeOf(Uploader)).call(this, props));

    _this.state = {
      url: null
    };

    _this.handleSaveClick = _this.handleSaveClick.bind(_this);
    _this.handleUrlChange = _this.handleUrlChange.bind(_this);
    return _this;
  }

  _createClass(Uploader, [{
    key: "handleSaveClick",
    value: function handleSaveClick() {
      var _props = this.props,
          onConfirm = _props.onConfirm,
          uploadAvatar = _props.uploadAvatar;


      this.cropper.getCrop().then(function (blob) {
        uploadAvatar(blob);
      }).then(function (blob) {
        onConfirm(blob);
      });
    }
  }, {
    key: "handleUrlChange",
    value: function handleUrlChange(url) {
      this.setState({ url: url });
    }
  }, {
    key: "maybeRenderCropper",
    value: function maybeRenderCropper() {
      var _this2 = this;

      var url = this.state.url;

      var ref = function ref(c) {
        _this2.cropper = c;
      };

      if (url) {
        return _react2.default.createElement(_Cropper2.default, { dataUrl: url, ref: ref });
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var onReject = this.props.onReject;
      var url = this.state.url;

      return _react2.default.createElement(
        _UIModal2.default,
        null,
        _react2.default.createElement(_UIDialogCloseButton2.default, { onClick: onReject }),
        _react2.default.createElement(
          _UIDialogHeader2.default,
          null,
          _react2.default.createElement(
            "h4",
            null,
            "Choose and crop an image"
          )
        ),
        _react2.default.createElement(
          _UIDialogBody2.default,
          null,
          _react2.default.createElement(
            _UISection2.default,
            null,
            _react2.default.createElement(_DropzoneUploader2.default, { onChange: this.handleUrlChange })
          ),
          _react2.default.createElement(
            _UISection2.default,
            null,
            this.maybeRenderCropper()
          )
        ),
        _react2.default.createElement(
          _UIDialogFooter2.default,
          null,
          _react2.default.createElement(
            _UIButton2.default,
            {
              onClick: this.handleSaveClick,
              use: "primary",
              disabled: url === null
            },
            "Save"
          ),
          _react2.default.createElement(
            _UIButton2.default,
            { onClick: onReject },
            "Cancel"
          )
        )
      );
    }
  }]);

  return Uploader;
}(_react.Component);

Uploader.propTypes = _extends({
  uploadAvatar: _react.PropTypes.func.isRequired
}, _PromptablePropInterface2.default);

exports.default = (0, _Promptable2.default)(Uploader);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./js/components/avatar/Uploader.js
// module id = 533
// module chunks = 171